<template>
    <div id="content">
        <div id="search" class="bg-light rounded d-block">
            <b-form @submit.prevent.stop="onSearch" @reset="onSearchReset" inline>
                <b-input class="mb-2 mr-sm-2 mb-sm-0 form-control-range" placeholder="Name"
                         v-model="search.name"></b-input>
                <b-input class="mb-2 mr-sm-2 mb-sm-0 form-control-range" placeholder="Surname"
                         v-model="search.surname"></b-input>
                <b-input type="number" class="mb-2 mr-sm-2 mb-sm-0 form-control-range" placeholder="Phone"
                         v-model="search.phoneNumber"></b-input>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.userGroups"
                               v-model="search.group"></b-form-select>
                <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0" v-model="search.isReady">is Ready</b-form-checkbox>
                <div class="ml-auto">
                    <b-button type="reset" class="mb-2 mr-sm-2 mb-sm-0">Reset</b-button>
                    <b-button type="submit" variant="primary" class="mb-2 mb-sm-0" :disabled="loading">Search</b-button>
                </div>
            </b-form>
        </div>

        <loader v-if="loading"></loader>
        <div id="list" v-else>
            <div v-if="data.data.length > 0">
                <b-table small striped hover :items="data.data" :fields="search.fields">
                    <template v-slot:cell(name)="data">
                        <router-link :to="{ name: 'userDetail', params: { id: data.item.id }}">{{data.value}}</router-link>
                    </template>

                    <template v-slot:cell(surname)="data">
                        <router-link :to="{ name: 'userDetail', params: { id: data.item.id }}">{{data.value}}</router-link>
                    </template>

                    <template v-slot:cell(phoneNumber)="data">
                        <router-link :to="{ name: 'userDetail', params: { id: data.item.id }}">{{data.value}}</router-link>
                    </template>

                    <template v-slot:cell(groups)="data">
                        <span v-for="group in data.value" :key=group.id>
                            <group :group="group" />
                        </span>
                    </template>
                    <template v-slot:cell(createdAt)="data">
                        {{ data.value | moment("MMMM Do YYYY") }}
                    </template>
                </b-table>
                <div class="ml-auto">
                    <b-pagination
                            @change="setPage"
                            :disabled="loading"
                            align="right"
                            v-model="data.page"
                            :total-rows="data.total"
                            :per-page="search.perPage"
                    ></b-pagination>
                </div>
            </div>

            <div class="card text-center" v-else>
                <div class="card-body">
                    <h5 class="card-title">Search Result</h5>
                    <p class="card-text">No Data</p>
                    <b-button @click="onSearchReset" variant="primary">Reset</b-button>
                </div>
                <div class="card-footer text-muted">
                    {{JSON.stringify(search)}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ContentLoader from '../../../components/ContentLoader';
  import GroupRender from '../../../components/GroupRender';
  import GetUsers from '../../../store/actions/getUsers';
  import ShowError from '../../../helpers/showError';

  export default {
    name: 'Users',
    components: {
      loader: ContentLoader,
      group: GroupRender
    },
    created() {
      this.onSearch();
    },
    data() {
      return {
        data: {
          data: []
        },
        loading: true,
        userGroups: this.$store.state.groups.map(item => ({text: item.title, value: item.id})),
        search: {
          perPage: 20,
          page: 1,
          name: undefined,
          surname: undefined,
          phoneNumber: undefined,
          group: undefined,
          isReady: true,
          fields: ['id', 'name', 'surname', 'phoneNumber', 'groups', 'createdAt']
        }
      }
    },
    methods: {
      setPage(page){
        this.search.page = page;
        this.onSearch();
      },
      async onSearch() {
        try {
          this.loading = true;
          this.data = await GetUsers(this.search);
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      onSearchReset() {
        this.search = {
          perPage: 20,
          page: 0,
          name: undefined,
          surname: undefined,
          phoneNumber: undefined,
          group: undefined,
          isReady: true,
          fields: this.search.fields
        };
        this.onSearch();
      }
    }
  }
</script>


<style scoped>
    #search {
        margin: 10px 0;
        padding: 10px;
    }
</style>
